import React from "react";
import InfoTooltip from "./InfoTooltip";
import { formatPrice } from "../../helpers/utils";
import AffirmPrequalify from "../AffirmPrequalify/AffirmPrequalify";

export default function N3BundlesInfo({ item, onCloseHandler }) {
  return (
    <div className="n3-products-col">
      <div
        className={`n3-products-wrapper ${
          item.newPrice && `best-seller-n3-border`
        }`}
      >
        {item.newPrice && (
          <div className="n3-best-seller">
            <i aria-hidden="true" className="fas fa-star"></i>
            <i aria-hidden="true" className="fas fa-star"></i>
            <i aria-hidden="true" className="fas fa-star"></i>
            <span>Best Seller</span>
            <i aria-hidden="true" className="fas fa-star"></i>
            <i aria-hidden="true" className="fas fa-star"></i>
            <i aria-hidden="true" className="fas fa-star"></i>
          </div>
        )}
        <div className="n3-products-iamge-wrapper">
          <img
            src={item?.image[0]?.url}
            alt={item?.image[0]?.alternativeText}
          />
        </div>
        <div className="n3-products-title-wrapper">
          <h3>{item?.title}</h3>
        </div>
        <div className="n3-products-price-wrapper">
          <span className="n3-actual-price-bundles">
            {item?.newPrice ? `$${formatPrice(item?.price)}` : ""}
          </span>
          {item.newPrice ? (
            <span style={{ color: "#d3222a" }}>{`$${formatPrice(
              item?.newPrice
            )}`}</span>
          ) : (
            <span style={{ marginTop: 20 }}>{`$${formatPrice(
              item?.price
            )}`}</span>
          )}
          <p>+ Free Shipping</p>
          {item.newPrice && (
            <span className="n3-you-save">{`You Save $${(
              item?.price - item?.newPrice
            ).toFixed(2)}`}</span>
          )}
        </div>

        {item?.price > 0 && item?.price && (
          <div className="n3-bundle-finance">
            <AffirmPrequalify price={item.price} newPrice={item?.newPrice} />
          </div>
        )}
        <div className="product-elite-button-wrapper update-button-wrapper">
          <a>
            <button onClick={() => onCloseHandler(item)}>ADD TO CART</button>
          </a>
        </div>
        <div className="white-glove-av">
          White Glove Assembly available in cart
        </div>
        <div className="divider-wrapper">
          <div />
        </div>
        <div className="div-feature-includes-wrapper">
          <h4> Includes </h4>
          <ul className="div-feature-includes">
            {item?.Includes &&
              item?.Includes?.length > 0 &&
              item.Includes?.map((items: any, i: number) => <InfoTooltip key={i} items={items} /> )}
          </ul>
        </div>
      </div>
    </div>
  );
}
